export default __webpack_public_path__ + "static/media/menubar_image.75f584b3.png";